import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { getUserRoles } from '../../state/auth/auth.selectors';
import { getFirstAllowedRoute } from '../../shared/utils/navigation-permissions.util';

export const defaultRouteGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(getUserRoles).pipe(
    take(1),
    map((roles): UrlTree => {
      const targetRoute = getFirstAllowedRoute(roles ?? []);
      return router.createUrlTree([targetRoute]);
    }),
  );
};